export enum NewsLetterText {
	heading = 'Join Our Newsletter',
	content = 'Be the first to catch new brands and industry trends on Beacon Discovery, every month.',
	submit = 'Submit'
}
